const state = {
  sidebarCollapsed: localStorage.getItem('sidebarCollapsed') === 'true',
  loading: false,
  snackbar: {
    show: false,
    message: '',
    color: 'success',
  },
}

const getters = {
  sidebarCollapsed: (state) => state.sidebarCollapsed,
  loading: (state) => state.loading,
  snackbar: (state) => state.snackbar,
}

const mutations = {
  TOGGLE_SIDEBAR(state) {
    state.sidebarCollapsed = !state.sidebarCollapsed
    localStorage.setItem('sidebarCollapsed', state.sidebarCollapsed)
  },
  SET_SIDEBAR_COLLAPSED(state, collapsed) {
    state.sidebarCollapsed = collapsed
    localStorage.setItem('sidebarCollapsed', collapsed)
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SHOW_SNACKBAR(state, { message, color = 'success' }) {
    state.snackbar = { show: true, message, color }
  },
  HIDE_SNACKBAR(state) {
    state.snackbar.show = false
  },
}

const actions = {
  toggleSidebar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  showSuccess({ commit }, message) {
    commit('SHOW_SNACKBAR', { message, color: 'success' })
  },
  showError({ commit }, message) {
    commit('SHOW_SNACKBAR', { message, color: 'error' })
  },
  showWarning({ commit }, message) {
    commit('SHOW_SNACKBAR', { message, color: 'warning' })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
